/*
	日期：2025/08/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：面包屑导航
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
*/
import Cookies from 'js-cookie'

export default {
	namespaced: true, // 添加这一行
	
	state: {
		// 用户控制菜单的展开和收缩
		isCollapse: false,
		
		// 面包屑数据
		tabsList: [
			{
				path: "/Home",
				name: "Home",
				label: "首页",
				icon: "s-home",
				url: "Home.vue", 
			}
		],
		menu: [],
	},
	
	mutations: {
		// 修改菜单湛河收缩的方法
		collapseMenu(state) {
			state.isCollapse = !state.isCollapse;
		},
		
		// 更新面包屑数据
		selectMenu(state, val) {
			//console.log(val, 'val');
			const curIndex = state.tabsList.findIndex(item => item.path === val.path)
			// 判断添加的数据是否存在
			if(curIndex === -1) {
				state.tabsList.push(val);
				//console.log(state.tabsList);
			}
		},
		
		// 删除指定tab数据
		deleteTabs(state, tabIndex) {
			//console.log(tabIndex,'tabIndex');
			//console.log(item,'item');
			//const tabIndex = state.tabsList.findIndex(tab => tab.name == item.name);
			state.tabsList.splice(tabIndex, 1);
			//console.log(index,'index');
		},
		
		// 设置MENU数据
		setCurUserMenu(state, menuData) {
			state.menu = menuData;
			/*
			const curUserLogin = Cookies.get('curUserLogin');
			if(curUserLogin) {
				const { menu: menuCookie } = JSON.parse(curUserLogin);
				//console.log("menuCookie:", menuCookie);
				if(menuCookie) {
					state.menu = menuCookie;
				}
				else {
					state.menu = menuData;
				}
			} else {
				state.menu = menuData;
			}
			//console.log('menuCookie:',menuCookie);
			//console.log('menuData:',menuData);*/
		},
		getCurUserMenu() {
			//commit 调用没有返回值 ？？？
			const curUserMenu = localStorage.getItem('curUserMenu');
			//console.log(curUserMenu);
			if(curUserMenu) {
				const menu = JSON.parse(curUserMenu);
				//console.log(menu);
				return menu;
			}
			else
			{
				return false;
			}
		},
		
		// 动态注册路由
		setRouterRules(state, val) {
			//const curUserMenuT = Cookies.get('curUserMenu');
			const curUserMenuT = localStorage.getItem('curUserMenu');
			//console.log(curUserMenuT);
			const { router, menu } = val;
			let curUserMenu;
			if(curUserMenuT) {
				//const { menu: menuCookie } = JSON.parse(curUserMenuT);
				const menuCookie = JSON.parse(curUserMenuT);
				//console.log("menuCookie:", menuCookie);
				curUserMenu = menuCookie;
				
			}
			else if(menu) {
				//console.log('menu:',menu);
				curUserMenu = menu;
			}
			else {
				//console.error("curUserMenu Error!");
			}
			//console.log('router:', router);
			//console.log('menu result:', curUserMenu);
			if(curUserMenu) {
				const routesArray = [];
				//console.log('menu:',curUserMenu);
				//const test = () => import('../views/Home.vue');
				curUserMenu.forEach(item => {
					if(item.children) {
						//console.log("item:", item);
						//console.log("item.file:", item.file);
						// 这种也可以
						//item.component = () => import(`${item.file}`);
						//item.component = () => import(`../views/${item.file}`);
						// 以下不行，不知道为什么
						//item.component = () => import('../' + item.file);
						//item.component = () => import('../views/Home.vue');
						item.children = item.children.map(subitem => {
							//console.log('subitem:', subitem);
							subitem.component = () => import(`../views/${subitem.file}`);
							return subitem;
						});
						//item.component = () => import(`../views/${item.file}`);
						routesArray.push(...item.children);
					} else {
						//console.log("item.file:", item.file);
						//console.log('item:',item);
						item.component = () => import(`../views/${item.file}`);
						routesArray.push(item);
					}
				});
				//console.log('routesArray:', routesArray);
				routesArray.forEach( routeItem => {
					// 校验路由是否存在，如果没有则添加
					const routeExists = router.getRoutes().some(
						route => route.name === routeItem.name
					  );
					if (!routeExists) {
						// 此处必须用 对应动态值的 name
						if(routeItem.top == 3)
							router.addRoute(null, routeItem);
						else
							router.addRoute('main', routeItem);
					}
				});
				/**
				routesArray.forEach( routeItem => {
					// 校验路由是否存在，如果没有则添加
					const routeExists = router.getRoutes().some(
						route => route.name === routeItem.name
					  );
					if (!routeExists) {
						// 此处必须用 对应动态值的 name
						//console.log('router error:',routeItem.name,routeItem);
					} else {
						//console.log('router right:',routeItem.name,routeItem);
					}
				});*/
				/*
				//创建 router 实例，然后传 `routes` 配置
				// 你还可以传别的配置参数, 不过先这么简单着吧。
				const router = new VueRouter({
					routes // (缩写) 相当于 routes: routes
				})

				// 4.将当前实例对外进行暴露
				export default router*/
			}
		}
	}
} 